import anime from 'animejs';

import {ConnectedComponent} from '@lib/ConnectedComponent';
import {MediaQuery} from '@services/MediaQuery';
import {ViewportObserver} from '@services/ViewportObserver';

const LAZY_MARGIN = '-100px';

export class Video extends ConnectedComponent {
  private mq = MediaQuery.create();
  private video: HTMLVideoElement | null = null;
  private img: HTMLImageElement | null = null;
  private observer: ViewportObserver | null = null;
  private sound: HTMLElement | null = null;
  private icon: HTMLElement | null | undefined = null;
  private muted = true;

  constructor() {
    super();
    this.onPressMuted = this.onPressMuted.bind(this);
    this.onCanPlay = this.onCanPlay.bind(this);
  }

  onPressMuted() {
    if (this.video) {
      this.video.muted = !this.muted;
      this.muted = this.video?.muted;
      if (this.muted) {
        this.icon?.classList.remove('on');
        this.icon?.classList.add('off');
      } else {
        this.icon?.classList.remove('off');
        this.icon?.classList.add('on');
      }
    }
  }

  didMount() {
    this.sound = document.documentElement.querySelector('.s-our-purpose_sound');
    this.sound?.addEventListener('click', this.onPressMuted);
    this.icon = this.sound?.querySelector('.a-sound-icon');

    this.observer = new ViewportObserver({margin: LAZY_MARGIN, ratio: 0});

    this.observer.onChange.connect((type) => {
      if (type === 'above' || type === 'below') {
        this.play();
      } else if (type === 'below-pre' || type === 'above-pre') {
        this.pause();
      }
    });
    this.observer.observe(this.element);

    this.video = this.element?.querySelector('video') as HTMLVideoElement;
    this.img = this.element?.querySelector('.a-video_img') as HTMLImageElement;

    if (this.mq.isDesktop()) {
      this.video.addEventListener('canplay', this.onCanPlay);
      this.video.preload = 'auto';
      // this.video.load();
    }
  }

  didUnmount() {
    this.sound?.removeEventListener('click', this.onPressMuted);
    this.observer?.unobserve(this.element);
  }

  onCanPlay() {
    // FIXME:
  }

  play() {
    this.video?.play();
    anime({
      duration: 300,
      easing: 'easeInOutCubic',
      opacity: 0,
      targets: this.img,
    });
  }

  pause() {
    anime({
      duration: 300,
      easing: 'easeInOutCubic',
      opacity: 1,
      targets: this.img,
    });
    this.video?.pause();
  }
}
